import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const InBrainAi = ({})=> {

  const hash      = 'Y014a0JPZnFDU3pHT2FIQ1NmQVVRSFlRZ3JaWnFoL0dPSGRrTWZUZC9SemkreHpHc0tYRVZGUFJvVzRBNEIzMFZQNHB1aXVWZWQ0M2ZQeVo2OFJUZS9saVVMY3U3dmRrR05lcEZVUTZVZnhRWTRFU3VKWW9hZzZyQ3JCbDJ0emlLb2Z6d0xMTWw2bnZ3d2pBY0NFTzBEUHFlTFMxa25uZzRTRzQzNlRZc0N4cGJOWEw1YWZ5Y1lCL2Q0S25LeGVMU3JxMUQ3WkJjM1J5bFYwcmxUQ1RlUT09';
  const currentUser = security.currentUserValue;

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/surveys" showLogo={true} />

      <iframe
        width="100%"
        frameBorder="0"
        style={{height: "100vh", margin: 0, padding: 0, border: 0}}
        src={`https://www.surveyb.in/configuration?params=${hash}&app_uid=${currentUser.id}`}
      ></iframe>

    </Fragment>
  );
};

export default InBrainAi;
